// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2NBhr","footer":"styles_footer__1Vnkb","passCodeTooltip":"styles_passCodeTooltip__WdcD1"};